import { render, staticRenderFns } from "./AffectTypeNew.vue?vue&type=template&id=31a63276"
import script from "./AffectTypeNew.vue?vue&type=script&lang=js"
export * from "./AffectTypeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports